import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/ic_暂无数据.svg'


const _hoisted_1 = { class: "view1" }
const _hoisted_2 = {
  class: "view2 radius-view1 main-view",
  style: {"height":"90%"}
}
const _hoisted_3 = { style: {"position":"relative","margin-top":"20px"} }
const _hoisted_4 = { style: {"font-size":"12px"} }

export function render(_ctx, _cache) {
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_alert, {
        closable: false,
        title: "用户精灵兑换管理",
        type: "warning"
      }),
      _createVNode(_component_el_form, {
        ref: "searlf",
        style: {"margin-top":"30px"},
        inline: true,
        model: _ctx.search,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "兑换码",
            class: "form-item",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.orderNumber,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.search.orderNumber) = $event)),
                class: "form-item-view",
                placeholder: "通过兑换码搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "物品名称",
            class: "form-item",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.search.name) = $event)),
                class: "form-item-view",
                placeholder: "通过物品名称搜索"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            class: "form-item",
            prop: "deleted"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.search.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.search.status) = $event)),
                class: "form-item-view",
                placeholder: "核销状态"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "待审核",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "已核销",
                    value: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.getList(1)))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("搜索")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("重置")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.list.list,
        border: "",
        stripe: "",
        class: "table",
        style: {"margin-top":"20px"}
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { label: "用户头像" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_image, {
                onClick: $event => (_ctx.gotoImg(scope.row.user.img)),
                style: {"width":"40px","height":"40px","border-radius":"90px"},
                src: scope.row.user.img,
                class: "avatar"
              }, null, 8, ["onClick", "src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "用户昵称"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.user.nickName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "用户ID"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.user.openId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "兑换物品图片" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_image, {
                onClick: $event => (_ctx.gotoImg(scope.row.shop.img)),
                style: {"width":"80px","height":"80px"},
                src: scope.row.shop.img,
                class: "avatar"
              }, null, 8, ["onClick", "src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "兑换物品名称"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.shop.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "兑换积分"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.price) + " 积分 ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "兑换数量"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.count), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            class: "table-column",
            label: "状态"
          }, {
            default: _withCtx((scope) => [
              (scope.row.status==0)
                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("待审核")
                    ])),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("已兑换")
                    ])),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "兑换时间" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.dateFormat(scope.row.createTime, 'yyyy年M月d日 HH点mm分')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "核销时间" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.changeTime ? _ctx.dateFormat(scope.row.changeTime, 'yyyy年M月d日 HH点mm分') : ''), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              (scope.row.status==0)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 0,
                    onConfirm: $event => (_ctx.changeStatus(scope.row,1)),
                    title: "核销后，请及时兑换物品给用户"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "text",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("核销")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (_ctx.list.list.length>0)
          ? {
              name: "empty",
              fn: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"color":"#C0C4CC"} }, [
                  _createElementVNode("div", { style: {"text-align":"center"} }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      style: {"height":"100px","width":"100px"}
                    }),
                    _createElementVNode("div", null, " 暂无数据 ")
                  ])
                ], -1))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["data"]),
      (_ctx.list.total>0)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            type: "flex",
            align: "middle",
            style: {"width":"100%","margin-top":"20px","padding-bottom":"40px"},
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, " 共" + _toDisplayString(_ctx.list.total) + "条 ", 1),
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "prev, pager, next",
                "page-size": _ctx.search.ps,
                "current-page": _ctx.search.pi,
                onCurrentChange: _cache[4] || (_cache[4] = $event => (_ctx.getList($event))),
                total: _ctx.list.total
              }, null, 8, ["page-size", "current-page", "total"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}